module.exports = __webpack_public_path__ + "img/yellow-ring.bf40f141.png";